const UUID_V4_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';

/** Build a standards-compliant UUID v4 when Web Crypto randomUUID is unavailable. */
export function createFallbackUuidV4(randomSource = Math.random) {
  return UUID_V4_TEMPLATE.replace(/[xy]/g, (character) => {
    const randomValue = Math.floor(randomSource() * 16);
    const uuidValue = character === 'x' ? randomValue : ((randomValue & 0x3) | 0x8);
    return uuidValue.toString(16);
  });
}

/** Create the UUID v4 request identity required by idempotent mutation APIs. */
export default function createIdempotencyKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return createFallbackUuidV4();
}
